import * as actions from "../actions";
import typeToReducer from "type-to-reducer";

const initialState = {
  notified: false,
  notifying: false,
  error: false,
};

export const notification = typeToReducer({
  [actions.SEND_NOTIFICATION]: {
    PENDING: () => ({
      notifying: true,
      notified: false,
      error: false
    }),
    REJECTED: (state) => ({
      notifying: false,
      notified: false,
      error: true
    }),
    FULFILLED: (state, action) => ({
      notifying: false,
      notified: true,
      error: false
    })
  },
}, initialState);
